import styled from 'styled-components';

import { ModalHeading, ModalContent as OriginalModalContent } from '../../modal';

export const ModalContent = styled(OriginalModalContent)`
  .modal-inner {
    ${Styles.desktop`
    justify-content: center;
  `}
  }
`;

export { ModalHeading };
